import CategorySearch from './CategorySearch';

export default CategorySearch;
